/* eslint-disable no-undef */

import axios from 'axios';
import helpers from '../helpers/helpers';

var apiRoot;
if (window.location.hostname.includes('localdev')) {
  apiRoot = 'http://localdev.barleyboard.com:8080'
} else {
  apiRoot = 'https://dev-api.barleyboard.com'
}

function getSingleDisplay(displayId) {
  return axios({
      method: 'get',
      url: apiRoot + '/api/v1/display/' + displayId
    })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log(error.response.data.statusCode)
      if (error.response.data.statusCode === 401) {
        helpers.logOutParent();
        return;
      }
      return error;
    });
}

// function updateSingleDisplay(display) {
//   return axios.create({
//       withCredentials: true
//     })
//     .put(apiRoot + '/api/v1/display/' + display.id,display)
//     .then((response) => {
//       if (response.data.statusCode === 200) {
//         // Helpers.redirect('/display');
//       }
//       return response;
//     })
//     .catch((error) => {
//       console.log(error)
//       if (error.response.data.statusCode === 401) {
//         // Helpers.redirect('/login');
//         console.log('log out parent please');
//         helpers.logOutParent();
//         return;
//       }
//       return error;
//     });
// };

const display = {
  getSingleDisplay
  // updateSingleDisplay
};
export default display;



// WEBPACK FOOTER //
// ./src/api/display.js